import { render, staticRenderFns } from "./Dossie.vue?vue&type=template&id=12491196&scoped=true&"
import script from "./Dossie.vue?vue&type=script&lang=js&"
export * from "./Dossie.vue?vue&type=script&lang=js&"
import style0 from "./Dossie.vue?vue&type=style&index=0&id=12491196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12491196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
